import React from "react";
import { useParams } from "wouter";

import { Counterparty } from ".";
import { PmSelectPrompt } from "./PmSelectPrompt";

export const CounterpartyView = (): React.ReactElement => {
    const { id } = useParams<{ id: string }>();

    if (typeof id === "undefined" || id === "all") {
        return <PmSelectPrompt message="Select a client" />;
    }
    return (
        <div>
            <Counterparty clientId={id} />
        </div>
    );
};
